// using optimistic approcah here 

import React, { useState, useContext } from "react";
import { AuthContext } from '../store/ContextStore';

type PaginationProps = {
  totalPages: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  itemsPerPage: number;
  showItemsPerPage: boolean;
  onItemsPerPageChange: (itemsPerPage: number) => void;
};

const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  onPageChange,
  itemsPerPage,
  showItemsPerPage,
  onItemsPerPageChange,
}) => {
  const {team} = useContext(AuthContext)
  const [previousPage, setPreviousPage] = useState<number>(currentPage); // handle previous page
  const [itemsPerPageOptions] = useState([5, 10, 20, 50, 100]);
  const onItemsPerPageClick = (val: number) =>{
    console.log("teetdasdsd>>."+val)
    itemsPerPage = val
    onItemsPerPageChange(val)
  }
  

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const range = 2; // no. of pages to show around the current page
    let lastAddedWasEllipsis = false;

    for (let i = 1; i <= totalPages; i++) {
    //if the page is withing the range or the last or first we sshow the button else ellipsis
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - range && i <= currentPage + range)
      ) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => onPageChange(i)}
            className={`w-10 h-10 mx-1 rounded-full ${
              i === currentPage
                ? `text-white`
                : "text-gray-800 border border-gray-300 hover:bg-gray-200"
            }`}

            style={{
              background: i === currentPage ?  team.colorCode : "white" 
          }}
          >
            {i}
          </button>
        );
        lastAddedWasEllipsis = false; // Reset flag
      } else if (!lastAddedWasEllipsis) {
        pageNumbers.push(
          <span key={`ellipsis-${i}`} className="mx-2 text-gray-500">
            ...
          </span>
        );
        lastAddedWasEllipsis = true; // Set flag to true
      }
    }
    return pageNumbers;
  };

  const handlePageChange = async (page: number) => {
    // saving previuos page just in cae the api call  fails 
    setPreviousPage(currentPage); 

    // api call
    try {
      await onPageChange(page);
    } catch (error) {
      console.error("API error:", error);
      // if error occurs, revert to the previous page
      onPageChange(previousPage);
    }
  };

  return (
    <div className="grid grid-cols-[1fr_2fr_1fr] gap-2 w-full">
      <div className="flex items-center justify-center sm:justify-start flex-wrap gap-2 justify-self-center col-start-2">
        <button
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className={`w-10 h-10 mx-1 rounded-full border border-gray-300 ${
            currentPage === 1
              ? "text-gray-400 cursor-not-allowed"
              : "text-gray-800 hover:bg-gray-200"
          }`}
        >
          &laquo;
        </button>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`w-10 h-10 mx-1 rounded-full border border-gray-300 ${
            currentPage === 1
              ? "text-gray-400 cursor-not-allowed"
              : "text-gray-800 hover:bg-gray-200"
          }`}
        >
          &lt;
        </button>
        {renderPageNumbers()}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`w-10 h-10 mx-1 rounded-full border border-gray-300 ${
            currentPage === totalPages
              ? "text-gray-400 cursor-not-allowed"
              : "text-gray-800 hover:bg-gray-200"
          }`}
        >
          &gt;
        </button>
        <button
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
          className={`w-10 h-10 mx-1 rounded-full border border-gray-300 ${
            currentPage === totalPages
              ? "text-gray-400 cursor-not-allowed"
              : "text-gray-800 hover:bg-gray-200"
          }`}
        >
          &raquo;
        </button>
      </div>

      {showItemsPerPage && <div className="flex items-center justify-self-end">
        <span className="text-gray-600 mr-2">Items per page</span>
        <select
          value={itemsPerPage}
          onChange={(e) => onItemsPerPageClick(Number(e.target.value))}
          className="border border-gray-300 rounded-md p-2 text-gray-800 bg-white"
        >
          {itemsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>}
    </div>
  );
};

export default Pagination;

